import Swal from "sweetalert2";

import api from "./api";
import { FormaPagamentoDto } from "../shared/dtos/FormaPagamento.dto";

class FormaPagamentoService {
  async getAllFormaPagamento(): Promise<FormaPagamentoDto[]> {
    return api
      .get("/forma-pagamento/find-all")
      .then((response) => {
        return Promise.resolve(response.data as FormaPagamentoDto[]);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar forma de pagamento`);
        return Promise.reject(error);
      });
  }

  async getFormaPagamentoById(id: number): Promise<FormaPagamentoDto> {
    return api
      .get(`/forma-pagamento/get-by-id/${id}`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar forma de pagamento com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async createFormaPagamento(formaPagamentoData: FormaPagamentoDto): Promise<FormaPagamentoDto> {
    return api
      .post("/forma-pagamento/create", formaPagamentoData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, "Erro ao criar forma de pagamento");
        return Promise.reject(error);
      });
  }

  async updateFormaPagamento(id: number, formaPagamentoData: FormaPagamentoDto): Promise<FormaPagamentoDto> {
    return api
      .patch(`/forma-pagamento/update/${id}`, formaPagamentoData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao atualizar forma de pagamento com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async deleteFormaPagamento(id: number): Promise<void> {
    return api
      .delete(`/forma-pagamento/delete/${id}`)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        this.handleError(error, `Erro ao deletar forma de pagamento com ID ${id}`);
        return Promise.reject(error);
      });
  }

  private handleError(error: any, message: string): void {
    if (error.response) {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.response.data}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.message || "Erro desconhecido"}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  }
}

const formaPagamentoService = new FormaPagamentoService();
export default formaPagamentoService;
